import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class ServerAphCatalogApi{

    static getAphCatalogResources(aphSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(aphSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `aph/catalog/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static updateAphCatalogAvailability(aphCatalogItems: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(config.URL + `aph/catalog/`,
                requestTypes.PUT,
                JSON.stringify(aphCatalogItems),
                apiConstants.successMessage.catalog.CATALOG_AVAILABILITY_UPDATED
            ),
        );
    }

    static getWhatsNew() {
        return sendRequest(
            requestOptions(config.URL + `aph/catalog/whatsnew`,
                requestTypes.GET,
            ),
        );
    }
}

export const aphCatalogApi = config.environment.MODE === config.modes.SERVER ? ServerAphCatalogApi : ServerAphCatalogApi;
